import * as _ from 'lodash-es';
import type { Maybe } from '../../graphql/generated/graphql';

export default function entityPath(
  name: Maybe<string> | undefined,
  id: Maybe<string> | undefined,
) {
  if (id == null) {
    return '';
  }
  let prefix = _.kebabCase(name || '');
  if (prefix !== '') {
    prefix += '-';
  }
  return `${prefix}${id}`;
}
